module.exports = __webpack_public_path__ + "static/media/financial@3x.5aab14c5.png";